var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.383154 12.7824H2.98714V23.6129C2.98714 23.8267 3.15864 24 3.3703 24H7.78546C7.99711 24 8.16861 23.8267 8.16861 23.6129V12.8334H11.1621C11.3568 12.8334 11.5205 12.6859 11.5427 12.4905L11.9974 8.50328C12.0099 8.39357 11.9755 8.28372 11.9028 8.20142C11.8301 8.11905 11.726 8.0719 11.6168 8.0719H8.16877V5.57249C8.16877 4.81905 8.57031 4.43698 9.36237 4.43698C9.47525 4.43698 11.6168 4.43698 11.6168 4.43698C11.8285 4.43698 12 4.26364 12 4.04988V0.389961C12 0.176129 11.8285 0.00286452 11.6168 0.00286452H8.50985C8.48793 0.00178065 8.43927 0 8.36755 0C7.82845 0 5.9546 0.106916 4.4744 1.48266C2.83434 3.0072 3.06232 4.83259 3.1168 5.14908V8.07182H0.383154C0.1715 8.07182 0 8.24508 0 8.45892V12.3952C0 12.6091 0.1715 12.7824 0.383154 12.7824Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d087f1e6b51ad04d9b4b1b203fd0f182.svg";
export { ForwardRef as ReactComponent };